<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('settings.settingsLabel') }}</span>
        <h3 class="page-title">{{ $t('settings.confirmations.confirmations') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/ustawienia')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('settings.backToSettings') }}
        </d-button>
        <d-button theme="success" @click.prevent="$router.push('/ustawienia/potwierdzenia/nowe')">
          <i class="material-icons">add</i>
          {{ $t('settings.confirmations.addNewConfirmation') }}
        </d-button>
      </d-col>
    </d-row>

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">{{ $t('settings.confirmations.name') }}</th>
            <th scope="col" class="border-0" style="width: 300px;">{{ $t('settings.confirmations.products') }}</th>
            <th scope="col" class="border-0" style="width: 300px;">{{ $t('settings.confirmations.customers') }}</th>
            <th scope="col" class="border-0">{{ $t('ui.actions') }}</th>
          </tr>
        </thead>
        <tbody v-if="loaded">
          <tr
            v-for="(confirmation, index) of confirmations"
            :key="'confirmation-' + index">
            <td class="align-middle">
              {{ confirmation.name }}
            </td>
            <td>
              <template v-if="confirmation.products.length">
                <div
                  v-for="(product, pindex) of confirmation.products"
                  :key="'product-' + index + '-' + pindex">
                  <small>{{ product.code }}</small>
                </div>
              </template>
              <template v-else>
                &mdash;
              </template>
            </td>
            <td>
              <template v-if="confirmation.customers.length">
                <div
                  v-for="(customer, cindex) of confirmation.customers"
                  :key="'customer-' + index + '-' + cindex">
                  <small>{{ customer.code }}</small>
                </div>
              </template>
              <template v-else>
                &mdash;
              </template>
            </td>
            <td
              class="align-middle"
              style="width: 150px;">
              <d-button
                theme="primary"
                @click.native="$router.push('/ustawienia/potwierdzenia/edycja/' + confirmation.id)"
                class="mr-2"
                :title="$t('ui.edit')">
                <i class="material-icons">edit</i>
              </d-button>
              <d-button
                theme="danger"
                @click.native="removeConfirmation(confirmation.id)"
                :disabled="removeInProgress"
                :title="$t('ui.delete')">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="confirmations.length === 0">
            <td
              colspan="3"
              class="text-center">
              {{ $t('settings.confirmations.noConfirmationsToDisplay') }}&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        {{ $t('ui.dataLoading') }}&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
      </d-alert>
    </d-card>
  </d-container>
</template>

<script>
import ListUtils from './../utils/ListUtils.js';

export default {
  name: 'confirmations',
  data() {
    return {
      confirmations: [],
      loaded: false,
      loadError: false,
      removeInProgress: false
    };
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      ListUtils.loadItemsData(this, '/confirmations/items', 'confirmations', {}, 'get');
    },
    removeConfirmation (confirmationID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/confirmations/delete/',
        id: confirmationID,
        successTitle: this.$t('settings.confirmations.removeConfirmationSuccessTitle'),
        successText: this.$t('settings.confirmations.removeConfirmationSuccessText'),
        confirmTitle: this.$t('settings.confirmations.removeConfirmationConfirmTitle'),
        confirmText: this.$t('ui.deleteConfirmText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('settings.confirmations.removeConfirmationErrorText'),
        successAction: () => {
          this.removeInProgress = false;
          this.loadData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>

